import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4l0 16","key":"svg-0"}],["path",{"d":"M8 11a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2l0 -2","key":"svg-1"}]]

const IconLayoutAlignLeft = createReactComponent('outline', 'layout-align-left', 'LayoutAlignLeft', __iconNode);

export default IconLayoutAlignLeft;